// Package Imports
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import { rootRoute } from '@/core/routes'

// Module Imports
import { signOutStatusSchema } from '@/modules/auth/auth.schemas'
import AuthLayout from '@/modules/auth/pages/auth-layout.page'

export const authRoute = createRoute({
  id: 'authLayout',
  getParentRoute: () => rootRoute,
  component: AuthLayout,
})

export const signInRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/',
  validateSearch: signOutStatusSchema,
  component: lazyRouteComponent(
    () => import('@/modules/auth/pages/sign-in.page')
  ),
})

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/forgot-password',
  component: lazyRouteComponent(
    () => import('@/modules/auth/pages/forgot-password.page')
  ),
})

export const resetPasswordRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/reset-password',
  component: lazyRouteComponent(
    () => import('@/modules/auth/pages/reset-password.page')
  ),
})

export const updateEmailVerifyRoute = createRoute({
  getParentRoute: () => authRoute,
  path: '/update-email-verify',
  component: lazyRouteComponent(
    () => import('@/modules/auth/pages/update-email-verify.page')
  ),
})
